<template>
    <ion-page>
        <ion-content>
            <div class="wrap">
                <div class="login-form">
                    <div class="form-header">
                        <img
                            src="../assets/model_space_logo.png"
                            alt="Model Space"
                        />
                        <p>Please add your Stage Name</p>
                    </div>

                    <div class="form-group">
                        <ion-item>
                            <ion-input
                                @ionChange="
                                    _event =>
                                        (displayName = _event.detail.value)
                                "
                                type="text"
                                placeholder="Stage Name"
                                clearInput
                                clear-input="true"
                                required="true"
                            ></ion-input>
                        </ion-item>
                    </div>

                    <div class="form-group">
                        <ion-button @click="updateName" expand="full"
                            >Next</ion-button
                        >
                    </div>

                    <error-message
                        v-if="error"
                        v-bind:message="error"
                    ></error-message>
                </div>
                <!-- /.login-form -->
            </div>
            <!-- /.wrap -->
        </ion-content>
    </ion-page>
</template>

<script>
import firebase from "firebase"

export default {
    name: "DisplayName",
    data: function() {
        return {
            error: false,
            displayName: null
        }
    },
    methods: {
        async updateName() {
            const loading = await this.$ionic.loadingController.create({
                message: "Updating stage name..."
            })

            loading.present()

            firebase
                .auth()
                .currentUser.updateProfile({ displayName: this.displayName })
                .then(() => {
                    this.showToast("Welcome to Model Space!")
                    this.$router.push({ name: "dashboard" })
                })
                .catch(error => {
                    this.error = error.message
                })
                .finally(() => {
                    loading.dismiss()
                })
        },
        async showToast(message) {
            const toast = await this.$ionic.toastController.create({
                message: message,
                showCloseButton: true,
                position: "bottom",
                closeButtonText: "Done",
                duration: 20000
            })
            return await toast.present()
        }
    }
}
</script>

<style scoped>
.wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--ion-color-primary);
}

.login-form {
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
    border: 1px solid #ddd;
    padding: 2rem;
    background: #ffffff;
}

.form-input {
    background: #fafafa;
    border: 1px solid #eeeeee;
    padding: 12px;
    width: 100%;
}

.form-group {
    margin-bottom: 1rem;
}

.form-header {
    text-align: center;
    margin-bottom: 2rem;
}

.form-footer {
    padding-top: 16px;
    text-align: center;
}
</style>
